import React, { useState } from 'react';
import * as S from './styles';
import Texts from '../Texts';
import TusFileUpload from '../../helper/TusFileUpload';
import { useDispatch } from 'react-redux'; // اضافه کردن useDispatch
import { updateApplicationField } from '../../Slice/unifiedFormSlice'; // اضافه کردن اکشن
import uploadIcon from '/src/assets/images/application/folder-file-up.svg?url';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/material';

// استایل‌های Modal
const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '98%', sm: '90%', md: '80%' },
  maxWidth: { xs: '380px', sm: '600px', md: '900px' },
  height: { xs: '40vh', sm: '40vh', md: '80vh' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: { xs: 0.5, sm: 2 },
  borderRadius: '8px',
  overflow: 'hidden',
};
interface ApplicationStepTowProps {
  onFileSelected: (file: File | null, fileUrl?: string) => void;
}

const ApplicationStepTow: React.FC<ApplicationStepTowProps> = ({
  onFileSelected,
}) => {
  const dispatch = useDispatch(); // اضافه کردن dispatch
  const [errors, setErrors] = useState<string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  return (
    <>
      <S.Form>
        <S.SubTitle as="div">
          {Texts.ApplicationStepTow.subTitle.split('IPA')[0]}
          <span className="blue-text">IPA</span>
          {Texts.ApplicationStepTow.subTitle.split('IPA')[1]}
        </S.SubTitle>

        {errors.length > 0 && (
          <S.ErrorBox>
            {errors.map((error, index) => (
              <S.ErrorMessage key={index}>{error}</S.ErrorMessage>
            ))}
          </S.ErrorBox>
        )}

        <S.ButtonHelp onClick={handleOpenModal}>
          <S.IconHelp />
          {Texts.ApplicationStepTow.helplink}
        </S.ButtonHelp>
        <TusFileUpload
          onFilesSelected={(file, fileUrl) => {
            if (file && fileUrl) {
              onFileSelected(file, fileUrl);
              dispatch(
                updateApplicationField({
                  field: 'application_file_url',
                  value: fileUrl,
                }),
              ); // ذخیره URL در Redux
              setErrors([]);
            } else {
              onFileSelected(null);
              dispatch(
                updateApplicationField({
                  field: 'application_file_url',
                  value: null,
                }),
              ); // بازنشانی URL در Redux
              setErrors(['لطفاً یک فایل بارگذاری کنید.']);
            }
          }}
          imageSrc={uploadIcon}
          backgroundColor="#F0F0F0"
          uploadText={Texts.ApplicationStepTow.uploadIpa}
          acceptedFileTypes={['.ipa']}
        />
      </S.Form>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={modalStyle}>
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              paddingBottom: '56.25%',
              overflow: 'hidden',
            }}
          >
            <iframe
              src="https://www.aparat.com/video/video/embed/videohash/mmvt09e/vt/frame"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              allowFullScreen={true}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ApplicationStepTow;
